import $ from 'jquery';
import CPMeta from '../cp-meta';

const {CP_TYPE_YOUTUBE, CP_TYPE_KAKAOTV} = CPMeta.CPTypes;
const {KAKAOTV_NO_LIVE, YOUTUBE, YOUTUBE_CHANNEL_ID} = CPMeta.codes;

const {noop} = $;

/**
 * 클릭로그 파라미터 스트링을 생성한다.
 * @param {Object} params
 * @returns {string}
 */
function param(params) {
  return $.param($.extend({}, {dc: 'VO2', pg: 1, at: 'func'}, params));
}

function extParamFactory({cpId, channelId, isSMR}) {
  return {
    vclip: {
      bif_cp_id: cpId,
      bif_channel_id: channelId,
      is_smr: typeof isSMR === 'boolean' ? (isSMR ? '1' : '-1') : '',
      is_live: '-1'
    }
  };
}

/**
 * 같은 위치의 객체지만 플레이어를 여는지 닫는지에 따라 p값이 달라진다.
 * 같은 기능이라도 썸네일인지, 타이틀인지에 따라 p값이 달라진다.
 *
 * @param {MouseEvent} e
 * @param {boolean} isCloseAction
 * @param {number} clipsCount
 * @param {Clip} clip
 * @param {HTMLElement} currentTarget
 */
export function togglePlayerLog(e, isCloseAction, clipsCount, clip, currentTarget) {
  const isTab = SF.getParam('w') === 'vclip';
  const isTitle = !$(currentTarget).hasClass('thumb');

  /**
   *
   * 통검은 썸네일, 타이틀 클릭 여부와 관계없이 22로 같은 p값
   * 탭은 썸네일일경우 22, 타이틀일경우 32를 보냄
   */
  let p;
  if (isCloseAction) {
    p = isTab ? 12 : 9;
  } else {
    p = isTab ? (isTitle ? 32 : 22) : 22;
  }

  const params = param({
    p,
    r: clip.index + 1,
    rc: clipsCount,
    d: clip.dsid
  });

  const extParams = extParamFactory({
    cpId: clip.cp,
    channelId: clip.bifChannelId,
    isSMR: clip.isSMR
  });

  smartLog(e.currentTarget, params, e, extParams);
}

export function foldLog(e) {
  smartLog(e.currentTarget, param({e: 23}), e);
}

export function unfoldLog(e) {
  smartLog(e.currentTarget, param({e: 13}), e);
}

/**
 * 플레이어 하단의 추천영상/플레이리스트 영상 목록 아이템을 클릭했을 때 보내는 로그
 *
 * - 카카오 추천영상의 경우 vid 기반으로 smr 여부를 알 수 없다고 하여 별도의 분기가 필요하다.
 *
 * @param {number} rc
 * @param {Clip} clip
 * @param {MouseEvent} evt
 */
export function playlistLog({rc, clip, evt}) {
  const {cpType, isKakaoTVPlaylist, bifChannelId, index, dsid, videoId, isSMR} = clip;

  const isKakaoTV = cpType === CP_TYPE_KAKAOTV;
  const isYoutube = cpType === CP_TYPE_YOUTUBE;
  const params = param({
    at: 'func',
    p: isKakaoTVPlaylist ? 26 : 25,
    rc,
    r: index + 1,
    d: isYoutube ? dsid : videoId
  });

  const extLogParam = (() => {
    switch (true) {
      case isKakaoTVPlaylist:
        return extParamFactory({
          cpId: KAKAOTV_NO_LIVE,
          channelId: bifChannelId,
          isSMR
        });
      case isKakaoTV:
        return extParamFactory({
          cpId: KAKAOTV_NO_LIVE,
          channelId: '',
          isSMR: ''
        });
      case isYoutube:
        return extParamFactory({
          cpId: YOUTUBE,
          channelId: YOUTUBE_CHANNEL_ID,
          isSMR: false
        });
      default:
        return null;
    }
  })();

  smartLog(evt.target, params, evt, extLogParam);
}

/**
 * 동일한 영역에 p값이 변하지 않는 모든 로그를 바인딩 한다.
 * p값은 스태틱 하더라도 extParam은 로직에 따라 다르게 넣어줘야 한다.
 *
 * @param {jQuery} $ctx - 클릭로그 이벤트 루트가 될 jQuery 객체, 기본적으로 $('#vclipColl')
 * @param {function(number|string):Clip} getClipByIndex
 * @param {function():number} getResultCount
 * @param {function():Clip} nowPlaying
 * @param {object} definitions
 */
export function staticLogs($ctx,
                           {
                             getClipByIndex = noop,
                             getResultCount = noop,
                             nowPlaying = noop,
                             definitions
                           }) {
  $ctx.on('click', '[data-p]', function (e) {
    const $elem = $(this);
    const data = $elem.data();
    const elementIndex = $ctx.find('[data-type]').index($elem.closest('[data-type]'));
    const clip = elementIndex < 0 ? nowPlaying() : getClipByIndex(elementIndex); // 플레이어영역의 경우 elementIndex로는 받아올 수 없다.
    const {at, p, dc, extend, extParamSetter} = definitions[data.p];

    const paramObj = $.extend({
      at,
      p,
      r: clip ? clip.index + 1 : 1,
      rc: getResultCount(),
      d: clip ? clip.dsid : '',
      dc: dc || 'VO2'
    }, typeof extend === 'function' ? extend({event, target: this}) : {});

    const params = param(paramObj);

    const extParams = (() => {
      switch (true) {
        case typeof clip === 'undefined':
          return null;
        case typeof extParamSetter === 'function':
          return extParamFactory(extParamSetter(clip));
        default:
          return extParamFactory({
            cp: clip.cp,
            channelId: clip.bifChannelId,
            isSMR: clip.isSMR
          });
      }
    })();

    smartLog(this, params, e, extParams);

    // 클릭로그 u 리디렉팅이 서비스 구모듈에서 작동하지 않아 임의로 넣어둠
    // 2018.03.29에 정기배포후 필요없어질 코드
    if (paramObj.u) {
      setTimeout(() => {
        window.location.href = paramObj.u;
      }, 350);
    }
  });
}

/**
 * @typedef {Object} extParams
 * @property {string} bif_cp_id
 * @property {string} bif_channel_id
 * @property {string} is_smr
 * @property {string} is_live
 */
/**
 * 통검은 썸네일, 타이틀 클릭 여부와 관계없이 22로 같은 p값
 * 탭은 썸네일일경우 32, 타이틀일경우 22를 보냄
 */



/** WEBPACK FOOTER **
 ** ./src/VO2/libs/logger/click-log.js
 **/